<template>
  <board-list/>
</template>
<script>
import BoardList from '@/components/board-list/index.vue'
export default {
  components: { BoardList }
}
</script>
